import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFalLite from './falLite.reducer';

export const selectFalLiteState = createFeatureSelector<fromFalLite.FalLiteState>(fromFalLite.falliteFeatureKey);

export const setFALLiteSelectedFilters = createSelector(
  selectFalLiteState,
  (state: fromFalLite.FalLiteState) => state.fALLiteSelectedFilters
);
